var _a;
import { createContext } from '../../internal/create-context.js';
export var setNavigationContext = (_a = createContext({
    parent: 'none',
    value: '',
    expanded: false
}), _a[0]), getNavigationContext = _a[1], key = _a[2];
